import classNames from "classnames";
import { DateTime } from "luxon";
import { EventDisplayData } from "../../../../../../../../../common/sesh_types";
import { CalendarEventDisplayData, days } from "./calendar_page";

export function MobileCalendarCell(props: {
	index: number;
	day_offset: number;
	start_of_month: DateTime;
	events: CalendarEventDisplayData[];
	is_selected: boolean;
	setIsSelected: (index: number) => void;
}) {
	const date = props.start_of_month
		.plus({ days: props.day_offset })
		.startOf("day");

	const has_weekday_shown = props.index < 7;

	const now = DateTime.now().startOf("day");

	const is_today = now.toMillis() === date.toMillis();
	const is_in_past = date.toMillis() < now.toMillis();

	let day_element: JSX.Element | undefined;
	day_element = (
		<span
			className={classNames(
				"flex h-[20px] w-[20px] flex-col items-center justify-center rounded-[100%] font-bold",
				{
					"bg-sesh-primary text-black": is_today,
				}
			)}
		>
			{date.day}
		</span>
	);

	return (
		<div
			key={props.day_offset}
			className={classNames(
				"group/cell h-16 w-full border-b border-r border-sesh-dark hover:bg-base-light",
				{
					"border-l": props.index % 7 === 0,
					"border-t": props.index < 7,
					"bg-base-light": props.is_selected,
					"bg-base-dark": !props.is_selected,
				}
			)}
			onClick={() => props.setIsSelected(props.day_offset)}
		>
			<div
				className={classNames(
					"flex h-full flex-col items-center text-xs",
					{
						"opacity-50":
							is_in_past ||
							props.start_of_month.month !== date.month,
					}
				)}
			>
				<div
					className={classNames(
						"group/day relative flex w-full py-[2px] transition-all"
					)}
				>
					<div className="flex w-full flex-col items-center">
						{has_weekday_shown && <span>{days[props.index]}</span>}
						{day_element}
					</div>
				</div>
				{props.events.length > 0 && (
					<div className="flex h-full pb-4">
						<div className="my-auto h-[6px] w-[6px] rounded-[100%] bg-sesh-primary"></div>
					</div>
				)}
			</div>
		</div>
	);
}
